export const getRejectExhibition = (state) => {
	return state.showRejectExhibition
}

export const getDeletePayment = (state) => {
	return state.showDeletePayment
}